(function () {
  function init(section) {
    if (section.dataset.kzhbInit) return;
    var slides      = section.querySelectorAll('.kaze-hero__slide');
    var bullets     = section.querySelectorAll('.kaze-hero__bullet');
    var progressBar = section.querySelector('.kaze-hero__progress-bar');
    var total       = slides.length;
    if (total <= 1) return;
    section.dataset.kzhbInit = '1';

    var current   = 0;
    var rafId     = null;
    var startTime = null;
    var progressGen = 0;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay  = section.dataset.autoplay !== 'false' && !reduceMotion;
    var globalDuration = (parseInt(section.dataset.slideDuration, 10) || 5) * 1000;

    function getDuration(index) {
      var el = slides[index];
      var d  = parseInt(el.dataset.duration, 10);
      return (isNaN(d) || d <= 0 ? globalDuration / 1000 : d) * 1000;
    }

    function goTo(index) {
      progressGen++;
      slides[current].classList.remove('is-active');
      if (bullets[current]) bullets[current].classList.remove('is-active');
      current = ((index % total) + total) % total;
      slides[current].classList.add('is-active');
      if (bullets[current]) bullets[current].classList.add('is-active');
      if (autoplay) startProgress();
    }

    function startProgress() {
      cancelAnimationFrame(rafId);
      if (!progressBar) return;
      var myGen = ++progressGen;
      var duration = getDuration(current);
      startTime = performance.now();
      progressBar.style.transition = 'none';
      progressBar.style.width = '0%';
      rafId = requestAnimationFrame(function () {
        rafId = requestAnimationFrame(function tick(now) {
          if (myGen !== progressGen) return;
          var pct = Math.min((now - startTime) / duration * 100, 100);
          progressBar.style.transition = 'none';
          progressBar.style.width = pct + '%';
          if (pct < 100) { rafId = requestAnimationFrame(tick); }
          else { goTo(current + 1); }
        });
      });
    }

    bullets.forEach(function (btn) {
      btn.addEventListener('click', function () { goTo(parseInt(btn.dataset.target, 10)); });
    });

    var touchStartX = null;
    section.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
    section.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goTo(current + (diff > 0 ? 1 : -1));
      touchStartX = null;
    }, { passive: true });

    section.addEventListener('mouseenter', function () { cancelAnimationFrame(rafId); });
    section.addEventListener('mouseleave', function () { if (autoplay) startProgress(); });

    if (autoplay) startProgress();
  }

  function flush() {
    if (!document.querySelector('.kaze-hero')) return;
    var hw = document.querySelector('.kzh-wrap');
    if (hw) {
      var h = Math.round(hw.getBoundingClientRect().height);
      if (h > 0) document.documentElement.style.setProperty('--kz-header-h', h + 'px');
    }
    document.documentElement.classList.add('kz-hero-flush');
  }

  var resizeTimer = null;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(flush, 150);
  }

  function boot() { document.querySelectorAll('.kaze-hero').forEach(init); flush(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }
  window.addEventListener('resize', onResize);
  window.addEventListener('load', flush);
  document.addEventListener('shopify:section:load', boot);
})();
